// Stimulus controller manifest. Add a line when porting a new controller.
import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AdminFeedbackController from "./admin_feedback_controller"
application.register("admin-feedback", AdminFeedbackController)

import AdminNavController from "./admin_nav_controller"
application.register("admin-nav", AdminNavController)

import CompanySwitcherController from "./company_switcher_controller"
application.register("company-switcher", CompanySwitcherController)

import CopyTextController from "./copy_text_controller"
application.register("copy-text", CopyTextController)

import ElapsedTimeController from "./elapsed_time_controller"
application.register("elapsed-time", ElapsedTimeController)

import FlashDismissController from "./flash_dismiss_controller"
application.register("flash-dismiss", FlashDismissController)

import HealthPollController from "./health_poll_controller"
application.register("health-poll", HealthPollController)

import NameSuggesterController from "./name_suggester_controller"
application.register("name-suggester", NameSuggesterController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import BoardController from "./board_controller"
application.register("board", BoardController)

import VoiceController from "./voice_controller"
application.register("voice", VoiceController)

import ComposerController from "./composer_controller"
application.register("composer", ComposerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import AddTicketModalController from "./add_ticket_modal_controller"
application.register("add-ticket-modal", AddTicketModalController)

import ProdStatusController from "./prod_status_controller"
application.register("prod-status", ProdStatusController)

import NavScrollController from "./nav_scroll_controller"
application.register("nav-scroll", NavScrollController)

import WysiwygController from "./wysiwyg_controller"
application.register("wysiwyg", WysiwygController)

import KbTreeController from "./kb_tree_controller"
application.register("kb-tree", KbTreeController)
